<template>
  <v-row class="pa-5">
    <!-- Days To Board -->
    <v-col cols="12" md="6">
      <v-select
        v-model="BoardingDaysToBoard"
        :items="['1 day', '2 days, 1 night', '3 days, 2 nights', '4 days, 3 nights', '5 days, 4 nights','6 days, 5 nights', '7 days, 6 nights','8 days, 7 nights','9 days, 8 nights','10 days or more']"
        label="Days To Board"
      ></v-select>
    </v-col>

    <!-- Number of furkids -->
    <v-col cols="12" md="6">
      <v-select
        v-model="BoardingNumberOfFurkids"
        :items="['None','1 kid', '2 kids', '3 or more']"
        label="Number of Furkids"
      ></v-select>
    </v-col>

    <!-- My furry kid needs playtime -->
    <v-col cols="12">
      <v-checkbox
        hide-details
        v-model="BoardingPlaytimeCheckbox"
        label="My furry kid needs playtime."
      ></v-checkbox>
    </v-col>

    <!-- I will bring my furry kids food -->
    <v-col cols="12">
      <v-checkbox
        hide-details
        v-model="BoardingFoodCheckbox"
        label="I will bring my furry kids food."
      ></v-checkbox>
    </v-col>

    <!-- I have my own tick drop-on -->
    <v-col cols="12">
      <v-checkbox hide-details v-model="BoardingTickCheckbox" label="I have my own tick drop-on."></v-checkbox>
    </v-col>

    <!-- I will bring along my furry kid's toy  -->
    <v-col cols="12">
      <v-checkbox
        hide-details
        v-model="BoardingToyCheckbox"
        label="I will bring along my furry kid's toy."
      ></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    BoardingDaysToBoard: "",
    BoardingNumberOfFurkids: "",
    BoardingPlaytimeCheckbox: false,
    BoardingFoodCheckbox: false,
    BoardingTickCheckbox: false,
    BoardingToyCheckbox: false
  }),
  watch: {
    BoardingDaysToBoard: function(val) {
      this.$emit("change", "BoardingDaysToBoard", val);
    },
    BoardingNumberOfFurkids: function(val) {
      this.$emit("change", "BoardingNumberOfFurkids", val);
    },
    BoardingPlaytimeCheckbox: function(val) {
      this.$emit("change", "BoardingPlaytimeCheckbox", val);
    },
    BoardingFoodCheckbox: function(val) {
      this.$emit("change", "BoardingFoodCheckbox", val);
    },
    BoardingTickCheckbox: function(val) {
      this.$emit("change", "BoardingTickCheckbox", val);
    },
    BoardingToyCheckbox: function(val) {
      this.$emit("change", "BoardingToyCheckbox", val);
    }
  }
};
</script>